module.exports = __webpack_public_path__ + "img/p2.57569717.png";